module.exports = __webpack_public_path__ + "static/media/ybcard.4bc99cc4.png";